import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import ProductPage from "./pages/ProductPage";
import RealmPage from "./pages/RealmPage";
import AdminPage from "./pages/AdminPage";
import { Toaster } from "./components/ui/sonner";
import { Toaster as ShadcnToaster } from "./components/ui/toaster";
import "./styles/luxury.css";
import "./App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/product/:productSlug" element={<ProductPage />} />
          <Route path="/realm/:realmSlug" element={<RealmPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
      <ShadcnToaster />
    </div>
  );
}

export default App;
